import { useEffect } from 'react'

import { DatahubEvent } from '@space-lib/datahub'
import { useScript } from '@space-lib/hooks'

import { Status } from '@space-lib/hooks/useScript/enums'

import type { Membership } from '@space-shell/common/services/membership'
import { PixelUtils } from '@space-shell/common/utils/pixel'

import type { AuthType } from '@space-shell/core/store'

type UsePixelParams = {
  membershipInfo: Membership
  user: AuthType
}

export const usePixel = ({ user, membershipInfo }: UsePixelParams) => {
  const scriptStatus = useScript({ src: process.env.CDN_SUPER_PIXEL_INJECTOR as string })

  useEffect(() => {
    if (scriptStatus === Status.Error) {
      DatahubEvent.sendInjectionError({
        context: 'membership_catalog',
        eventId: PixelUtils.formatEventId(),
        errorTrigger: 'script_load_failed',
        errorType: 'generic_error',
        runtimeValues: [
          {
            code: 'id',
            value: user?.id ?? ''
          },
          {
            code: 'token',
            value: user?.token ?? ''
          },
          {
            code: 'ucode',
            value: user?.ucode ?? ''
          },
          {
            code: 'slug',
            value: membershipInfo.slug
          }
        ],
        userAgent: window.navigator.userAgent
      })
    }
  }, [membershipInfo?.slug, scriptStatus, user?.id, user?.token, user?.ucode])
}
